import React from 'react';
import { advanceRequestUrl } from '../../../../config/paths';
import { PAY_CARD } from '../../../../constants/Routes';
import { showAdvanceRequest } from '../../../../constants/Visible';
import AdvanceIcon from '../../../common/icons/advanceIcon';
import CardIcon from '../../../common/icons/cardIcon';

export const payCardGroup = () => {
  return showAdvanceRequest === 'on'
    ? [
        ...payCardGroupBase,
        {
          route: advanceRequestUrl,
          icon: <AdvanceIcon size="30px" />,
          title: 'Avance y súper avance',
          id: 'advanceAndSuperAdvanceSection',
          isNew: true,
          isRedirect: true,
        },
      ]
    : payCardGroupBase;
};

export const payCardGroupBase = [
  {
    route: PAY_CARD,
    icon: <CardIcon size="30px" />,
    title: 'Pagar Tarjeta Ripley',
    id: 'payRipleyCardSection',
  },
];
